import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

class TerminalForm extends PureComponent {
  constructor(props) {
    super(props);

    const { terminal } = props;
    if (terminal) {
      this.state = { ...terminal };
    } else {
      this.state = {
        name: '',
        serialId: '',
        location: '',
        status: 'IN_SERVICE',
        systemStatus: 'NO_SET',
        condition: 'IDLE',
        validated: false,
      };
    }
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleFieldChange = (event) => {
    switch (event.target.id) {
      case 'name': return (this.setState({ name: event.target.value }));
      case 'serialId': return (this.setState({ serialId: event.target.value }));
      case 'location': return (this.setState({ location: event.target.value }));
      case 'status': return (this.setState({ status: event.target.value }));
      case 'systemStatus': return (this.setState({ systemStatus: event.target.value }));
      case 'condition': return (this.setState({ condition: event.target.value }));
      default: return this.state;
    }
  }

  handleSubmit = (event) => {
    const { onSubmit } = this.props;

    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      const body = (({
        name, serialId, location, status, systemStatus, condition,
      }) => ({
        name, serialId, location, status, systemStatus, condition,
      }))(this.state);
      onSubmit(body);
    }
    this.setState({ validated: true });
  }

  render = () => {
    const {
      name, serialId, location, status, systemStatus, condition, validated,
    } = this.state;

    const { formId, onSubmit } = this.props;

    return (
      <Form noValidate validated={validated} onSubmit={this.handleSubmit} id={formId}>
        <Form.Row>
          <Col>
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={name}
                placeholder="Enter the BPT name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the BPT name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="serialId">
              <Form.Label>Serial ID</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={serialId}
                placeholder="Enter the BPT serial ID"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the BPT serial identifier.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="location">
              <Form.Label>Location</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                type="text"
                onChange={this.handleFieldChange}
                value={location}
                placeholder="Enter the location"
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                as="select"
                value={status}
                onChange={this.handleFieldChange}
              >
                <option>IN_SERVICE</option>
                <option>OUT_OF_SERVICE</option>
                <option>PARTIAL_SERVICE</option>
                <option>DECOMMISSIONED</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="systemStatus">
              <Form.Label>System Status</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                as="select"
                value={systemStatus}
                onChange={this.handleFieldChange}
              >
                <option>NO_SET</option>
                <option>ACTIVE</option>
                <option>INACTIVE</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="condition">
              <Form.Label>Condition</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                as="select"
                value={condition}
                onChange={this.handleFieldChange}
              >
                <option>IDLE</option>
                <option>IN_USE</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

TerminalForm.propTypes = {
  onSubmit: PropTypes.func,
  formId: PropTypes.string.isRequired,
  terminal: Shapes.TERMINAL,
};

TerminalForm.defaultProps = {
  terminal: null,
  onSubmit: undefined,
};

export default TerminalForm;
